import { useHistory, useLocation, useParams } from 'react-router-dom';
import { OverviewSource } from './tracksTypes';
import { useMemo } from 'react';
import { OVERVIEW_MODAL_PLAYLIST_PARAM, removeOverviewUrl, removeTrailingSlash } from '../../utils/RoutingUtils';
import { COURSE_OVERVIEW_URL_FRAGMENT, LESSON_OVERVIEW_URL_FRAGMENT } from '../../constants/Navigation';
import { useAssetTimeRemaining } from '../userProgress';
import { useTrack } from './tracksQueries';
import { useAllLessons } from '../lessons';
import { useFullPlaylist } from '../savedItems'; // @ts-expect-error Could not find a declaration file for module

import { useSearchParam } from '../../hooks/searchParamHooks';
export const useOverviewNavigationList = () => {
  const {
    source,
    trackId,
    lessonId
  } = useParams();
  const selectedId = parseInt(trackId || lessonId, 10);
  const selectedType = trackId ? 'TRACK' : 'LESSON';
  const [[playlistId]] = useSearchParam(OVERVIEW_MODAL_PLAYLIST_PARAM);
  const {
    playlist
  } = useFullPlaylist(Number(playlistId), !playlistId);
  const list = useMemo(() => {
    switch (source) {
      case OverviewSource.Playlist:
        return playlist ? playlist.items.map(({
          itemId,
          type,
          language
        }) => {
          return {
            id: itemId,
            type: type === 'TRACK' ? 'track' : 'lesson',
            language
          };
        }) : null;

      default:
        return null;
    }
  }, [source, playlist]);
  return {
    list,
    source,
    selectedId,
    selectedType
  };
};
export const useOverviewNavigation = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    source
  } = useParams();

  const closeOverview = () => {
    const pathname = removeTrailingSlash(removeOverviewUrl(location.pathname)) || '/';
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has(OVERVIEW_MODAL_PLAYLIST_PARAM)) searchParams.delete(OVERVIEW_MODAL_PLAYLIST_PARAM);
    history.replace(Object.assign({}, location, {
      pathname,
      search: searchParams.toString()
    }));
  };

  const goTo = ({
    id,
    type,
    language
  }) => {
    let sourceUrl = removeTrailingSlash(removeOverviewUrl(location.pathname));
    if (sourceUrl === '/') sourceUrl = '';
    const pathname = `${sourceUrl}${type === 'track' ? COURSE_OVERVIEW_URL_FRAGMENT : LESSON_OVERVIEW_URL_FRAGMENT}/${id}/${[source, language].filter(e => e).join('/')}`;
    history.push(Object.assign({}, location, {
      pathname
    }));
  };

  return {
    closeOverview,
    goTo
  };
};
export const useIsOverview = () => {
  const location = useLocation();
  return location.pathname.includes(COURSE_OVERVIEW_URL_FRAGMENT) || location.pathname.includes(LESSON_OVERVIEW_URL_FRAGMENT);
};
export const useTrackContentIds = trackId => {
  const {
    track,
    trackLoading
  } = useTrack(trackId);
  const {
    allLessons,
    allLessonsLoading
  } = useAllLessons();
  const trackContentIdsLoading = trackLoading || allLessonsLoading;
  const trackContentIds = useMemo(() => {
    if (!track || !allLessons || trackContentIdsLoading) return [];
    return track.lessonIds.flatMap(lessonId => allLessons[lessonId] ? allLessons[lessonId].contentIds : []);
  }, [allLessons, track, trackContentIdsLoading]);
  return {
    trackContentIds,
    trackContentIdsLoading
  };
};
export const useTrackProgressTime = trackId => {
  const {
    track
  } = useTrack(trackId);
  const {
    trackContentIds,
    trackContentIdsLoading
  } = useTrackContentIds(trackId);
  const totalTime = track && track.duration || 0;
  const {
    remainingTime,
    allProgressLoading
  } = useAssetTimeRemaining({
    id: trackId,
    type: 'TRACK',
    contentIds: trackContentIds,
    totalTime
  });
  return {
    remainingTime,
    totalTime,
    trackProgressTimeLoading: allProgressLoading || trackContentIdsLoading
  };
};